import { PlayerActivityLogType as PlayerActivityLogType } from '@/schema'

export const activityLogTypeTranslations: Record<
	PlayerActivityLogType,
	string
> = {
	[PlayerActivityLogType.RANK_CHANGE]: 'เปลี่ยนแปลง rank',
	[PlayerActivityLogType.RANK_PROMOTION]: 'เลื่อนระดับ',
	[PlayerActivityLogType.RANK_DEMOTION]: 'ตกระดับ',
	[PlayerActivityLogType.LOCKOUT]: 'ระงับบัญชี',
	[PlayerActivityLogType.CLEAR_LOCKOUT]: 'ยกเลิกระงับบัญชี',
	[PlayerActivityLogType.UPDATE_BANK_BY_ADMIN]: 'อัพเดทธนาคารโดยแอดมิน',
	[PlayerActivityLogType.UPDATE_WALLET_BY_ADMIN]: 'อัพเดทกระเป๋าเงินโดยแอดมิน',
	[PlayerActivityLogType.UPDATE_BANK]: 'อัพเดทธนาคาร',
	[PlayerActivityLogType.LUCKY_WHEEL_PLAY]: 'หมุนวงล้อนำโชค',
	[PlayerActivityLogType.DAILY_CHECK_IN]: 'เช็คอินประจำวัน',
	[PlayerActivityLogType.LOGIN]: 'เข้าสู่ระบบ',
	[PlayerActivityLogType.PROMOTION_REDEEM]: 'แลกโปรโมชั่น',
	[PlayerActivityLogType.RETURN_LOSS]: 'คืนยอดเสีย',
	[PlayerActivityLogType.WALLET_TRANSFER]: 'โอนเงินในกระเป๋า',
	[PlayerActivityLogType.DEPOSIT]: 'ฝากเงิน',
	[PlayerActivityLogType.WITHDRAW]: 'ถอนเงิน',
	[PlayerActivityLogType.CLEAR_TURNOVER]: 'ล้างยอดเทิร์น',
	[PlayerActivityLogType.COMMISSION_CASHBACK]: 'คืนค่าคอมมิชชั่น',
}
